import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';

import { FiCheckSquare } from 'react-icons/fi';
import { Row, Col } from 'react-bootstrap';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';

import getResponseErrors from '../../../utils/getResponseErrors';

import { Exame } from '../../ImpressaoDocumento/styles';
import { IOption } from '../../../components/SelectSync';
import { formatPrice } from '../../../utils/funcoes';

interface IProcedimentosComboDTO {
  ProCodigo: number;
  PerCodigo: number;
  CboCodigo: number;
  procedimento?: {
    ProCodigo?: number;
    ProPerCodigo?: number;
    ProNome?: string;
    ProAgendado?: boolean;
    ProDuracao?: number;
    perfil?: {
      PerCodigo?: number;
      PerNome?: string;
      PerTipo?: number;
    };
  };
}
interface IProcedimentosComboValor {
  ProCodigo: number;
  ProNome: string;
  ProValor: number;
  ProValorPlano: number;
  ProValorFormatado: string;
  ProValorPlanoFormatado: string;
  procedimentosCombo: IProcedimentosComboDTO[];
}

const ProcedimentosCombo: React.FC = () => {
  const { addToast } = useToast();
  const [procedimentos, setProcedimentos] = useState<
    IProcedimentosComboValor[]
  >([]);
  const [options, setOptions] = useState<IOption[]>();
  const [
    procedimentoSelecionado,
    setProcedimentoSelecionado,
  ] = useState<IProcedimentosComboValor>();

  useEffect(() => {
    async function loadDados(): Promise<void> {
      try {
        const response = await api.get<IProcedimentosComboValor[]>(
          `/procedimentos/combos`,
        );

        const retornoFormatado = response.data.map(proc => {
          return {
            ...proc,
            ProValorFormatado: formatPrice(proc.ProValor),
            ProValorPlanoFormatado: formatPrice(proc.ProValorPlano),
          };
        });

        setProcedimentos(retornoFormatado);

        const optionsProcedimento = retornoFormatado.map(op => {
          return {
            value: op.ProCodigo.toString(),
            label: op.ProNome,
          };
        });

        setOptions(
          optionsProcedimento.sort((a, b) => {
            const labelA = a.label.toUpperCase(); // ignore upper and lowercase
            const labelB = b.label.toUpperCase(); // ignore upper and lowercase
            if (labelA < labelB) {
              return -1;
            }
            if (labelA > labelB) {
              return 1;
            }

            // labels must be equal
            return 0;
          }),
        );
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar dados',
          type: 'error',
          description: mensagemErro,
        });
      }
    }
    loadDados();
  }, [addToast]);

  const handleOnChange = useCallback(
    (option: IOption | null) => {
      if (option !== null) {
        const codigo = Number(option.value);
        setProcedimentoSelecionado(
          procedimentos.find(pro => pro.ProCodigo === codigo),
        );
      }
    },
    [procedimentos],
  );

  return (
    <div style={{ fontSize: '1rem' }}>
      {procedimentos && (
        <Select name="combo" options={options} onChange={handleOnChange} />
      )}
      {procedimentoSelecionado && (
        <>
          <br />

          <Row noGutters>
            <Col md={6}>
              Valor: <b> {procedimentoSelecionado.ProValorFormatado}</b>
            </Col>

            <Col md={6}>
              Valor Associado:
              <b> {procedimentoSelecionado.ProValorPlanoFormatado}</b>
            </Col>
          </Row>
          <br />

          <Row noGutters>
            {procedimentoSelecionado.procedimentosCombo.map(pro => (
              <Col md={6} key={`pro-${pro.ProCodigo}`} className="mb-1">
                <Exame>
                  <FiCheckSquare size={22} /> {pro.procedimento?.ProNome}
                </Exame>
              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );
};

export default ProcedimentosCombo;
